import { fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';
import { putError } from '@/store/error.store';
import momentLocalizer from 'react-widgets-moment';
import { fixDate, ifExists } from '../../../../util/util';
import moment from 'moment';
moment.locale('en');
momentLocalizer();

export const volumeReportReducer = (state = fromJS({
  dateFrom: fixDate(moment().startOf('year').toDate()),
  dateTo: fixDate(moment().startOf('year').add(1, 'year').add(-1, 'day').toDate()),
}), action) => {
  switch (action.type) {
    case 'VOLUME_REPORT_UPDATE_DATE':
      return state.set('dateFrom', action.dateFrom).set('dateTo', action.dateTo);
    case 'VOLUME_REPORT_LOAD_COMPLETED':
      return state.set('totalSale', fromJS(action.data)
        .map(d => d.set('value', d.get('valueDestination'))))
        .set('totalPurchase', fromJS(action.data)
          .map(d => d.set('value', d.get('valueOrigin'))));
    case 'VOLUME_VS_PROFIT_REPORT_LOAD_COMPLETED':
      return state.set('totalSalesVsProfit', fromJS(action.data)
        .map(d => d.set('Volume', d.get('VolumeDestination'))
          .set('Profit', d.get('ProfitDestination'))).sortBy(a => a.get("Volume")).reverse())
        .set('totalPurchasesVsProfit', fromJS(action.data)
          .map(d => d.set('Volume', d.get('VolumeOrigin'))
            .set('Profit', d.get('ProfitOrigin'))).sortBy(a => a.get("Volume")).reverse());
    case 'SALE_PRODUCT_VOLUME_PROFIT_REPORT_LOAD_COMPLETED':
      return state.set('totalSaleVsProfitProducts', fromJS(action.data).sortBy(a => a.get("Sales")).reverse());
    case 'SALE_PRODUCT_VOLUME_REPORT_LOAD_COMPLETED':
      return state.set('totalSaleProducts', fromJS(action.data));
    default:
      return state;
  }
};

const requestFailure = (dispatch, type, data, reportType) => {
  putError(dispatch, data);
  dispatch({ type });
  markStoreLoaded(dispatch, reportType);
  return true;
};

const requestSuccess = (dispatch, type, data, reportType) => {
  dispatch({ type, data });
  markStoreLoaded(dispatch, reportType);
  return true;
};

const dateOrEmpty = (date) => ifExists(date).map(d => d.getTime()).orElse('');

export const totalQuantityVsProfitByProduct = (dispatch, dealType, dateFrom, dateTo) => {
  dispatch({ type: `${dealType.toUpperCase()}_PRODUCT_VOLUME_PROFIT_REPORT_LOAD_STARTING` });
  const reportType = `${dealType.toUpperCase()}_PRODUCT_VOLUME_PROFIT_REPORT`;
  markStoreLoading(dispatch, reportType);
  return RestAPI.get(`/api/report/totalquantityvsprofitbyproduct?dealType=${
    dealType}&from=${dateOrEmpty(dateFrom)}&to=${dateOrEmpty(dateTo)}`)
    .then(
      data =>
        requestSuccess(dispatch,
          `${dealType.toUpperCase()}_PRODUCT_VOLUME_PROFIT_REPORT_LOAD_COMPLETED`, data,
          reportType),
    ).catch(
      data =>
        requestFailure(dispatch,
          `${dealType.toUpperCase()}_PRODUCT_VOLUME_PROFIT_REPORT_LOADING_FAILED`, data,
          reportType),
    );
};

export const totalQuantityByProduct = (dispatch, dealType, dateFrom, dateTo) => {
  dispatch({ type: `${dealType.toUpperCase()}_PRODUCT_VOLUME_REPORT_LOAD_STARTING` });
  const reportType = `${dealType.toUpperCase()}_PRODUCT_VOLUME_REPORT`;
  markStoreLoading(dispatch, reportType);
  return RestAPI.get(`/api/report/totalquantitybyproduct?dealType=${dealType}&from=${
    dateOrEmpty(dateFrom)}&to=${dateOrEmpty(dateTo)}`)
    .then(
      data => requestSuccess(dispatch,
        `${dealType.toUpperCase()}_PRODUCT_VOLUME_REPORT_LOAD_COMPLETED`, data, reportType),
    ).catch(
      data => requestFailure(dispatch,
        `${dealType.toUpperCase()}_PRODUCT_VOLUME_REPORT_LOADING_FAILED`, data, reportType),
    );
};


export const totalQuantity = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'VOLUME_REPORT_LOAD_STARTING' });
  const reportType = 'VOLUME_REPORT';
  markStoreLoading(dispatch, reportType);
  return RestAPI.get(`/api/report/totalquantity?from=${dateOrEmpty(dateFrom)}&to=${
    dateOrEmpty(dateTo)}`)
    .then(
      data => requestSuccess(dispatch,
        'VOLUME_REPORT_LOAD_COMPLETED', data, reportType),
    ).catch(
      data => requestFailure(dispatch,
        'VOLUME_REPORT_LOADING_FAILED', data, reportType),
    );
};

export const totalQuantityVsProfit = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'VOLUME_VS_PROFIT_REPORT_LOAD_STARTING' });
  const reportType = 'VOLUME_VS_PROFIT_REPORT';
  markStoreLoading(dispatch, reportType);
  return RestAPI.get(`/api/report/totalquantityvsprofit?from=${dateOrEmpty(dateFrom)
  }&to=${dateOrEmpty(dateTo)}`)
    .then(
      data => requestSuccess(dispatch,
        'VOLUME_VS_PROFIT_REPORT_LOAD_COMPLETED', data, reportType),
    ).catch(
      data => requestFailure(dispatch,
        'VOLUME_VS_PROFIT_REPORT_LOADING_FAILED', data, reportType),
    );
};

export const updateDate = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'VOLUME_REPORT_UPDATE_DATE', dateFrom, dateTo });
};

